<template>
  <el-select class="cs-select" ref="select" v-bind="$attrs" v-on="$listeners">
    <template #prefix v-if="label">
      <span ref="prefix">{{ label }}:</span>
    </template>
    <slot></slot>
  </el-select>
</template>

<script lang="ts">
import { BaseComponent, Component, Prop, Watch, Vue } from 'kuaidong-component'

@Component
export default class CsSelect extends BaseComponent {
  @Prop({ type: String })
  label!: string

  mounted() {
    this.setInputStyle()
  }

  @Watch('label')
  onLabelChange() {
    this.setInputStyle()
  }

  async setInputStyle() {
    await this.$nextTick()

    const select = this.$refs.select as Vue
    const prefix = this.$refs.prefix as HTMLElement

    if (select && prefix) {
      const input = select.$el.querySelector<HTMLElement>('.el-input__inner')

      if (input) {
        input.style.paddingLeft = prefix.offsetWidth + 15 + 'px'
      }
    }
  }
}
</script>

<style lang="less">
.cs-select {
  > .el-input {
    > .el-input__prefix {
      left: 10px;
      color: #9da2a9;
    }
  }
}
</style>
